import React, { Component } from 'react';
import { Form, FormGroup, Label, Input, InputGroup, InputGroupAddon, Col, Container, Row, Button, ButtonGroup } from 'reactstrap';

export class InputQuestionCurrency extends Component {
    displayName = InputQuestionCurrency.name

    render() {
        return (
            <FormGroup className={this.props.className}>
                <Label for={this.props.name}>{this.props.title}</Label>
                <InputGroup>
                    <InputGroupAddon addonType="prepend">£</InputGroupAddon>
                    <Input type="number" name={this.props.name} value={this.props.value} onChange={this.props.onChange} />
                </InputGroup>
            </FormGroup>
        );
    }
}


export class InputQuestionNumber extends Component {
    displayName = InputQuestionCurrency.name

    render() {
        return (
            <FormGroup>
                <Label for={this.props.name}>{this.props.title}</Label>
                <Input type="number" name={this.props.name} value={this.props.value} onChange={this.props.onChange} />
            </FormGroup>
        );
    }
}


export class InputQuestionSelect extends Component {
    displayName = InputQuestionSelect.name

    render() {
        return (
            <FormGroup>
                <Label for={this.props.name}>{this.props.title}</Label>
                <Input type="select" name={this.props.name} value={this.props.value} onChange={this.props.onChange} >
                    {this.props.children}
                </Input>
            </FormGroup>
        );
    }
}

export class InputQuestionSelectOption extends Component {
    displayName = InputQuestionSelect.name

    render() {
        return (
            <option value={this.props.value}>{this.props.name}</option>
        );
    }
}

export class InputQuestionPercent extends Component {
    displayName = InputQuestionPercent.name

    render() {
        return (
            <FormGroup>
                <Label for={this.props.name}>{this.props.title}</Label>
                <InputGroup>
                    <Input type="number" name={this.props.name} value={this.props.value} onChange={this.props.onChange} />
                    <InputGroupAddon addonType="append">%</InputGroupAddon>
                </InputGroup>
            </FormGroup>
        );
    }
}

export class InputQuestionText extends Component {
    displayName = InputQuestionCurrency.name

    render() {
        return (
            <FormGroup>
                <Label for={this.props.name}>{this.props.title}</Label>
                <InputGroup>
                    <Input type="text" placeholder={this.props.title} name={this.props.name} value={this.props.value} onChange={this.props.onChange} />
                </InputGroup>
            </FormGroup>
        );
    }
}

export class InputQuestionRadioButtonGroup extends Component {
    render() {
        const childrenWithProps = React.Children.map(this.props.children, child =>
            React.cloneElement(child, { onClick: this.props.onClick, selectedValue: this.props.selectedValue })
        );

        return (
            <FormGroup>
                <Label for={this.props.name}>{this.props.title}</Label>
                <InputGroup>
                    <ButtonGroup>
                        {childrenWithProps}
                    </ButtonGroup>
                </InputGroup>
            </FormGroup>
        );
    }
}

export class InputQuestionRadioButton extends Component {
    render() {
        return (
            <Button color="primary" name={this.props.name} active={this.props.selectedValue === this.props.name} onClick={this.props.onClick}>
                {this.props.title}
            </Button >
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Inputs/InputQuestions.js